// @file Helpers that purely extend tldraw
import { useTldrawEditor } from '@@/vuecomposables/useTldrawEditor'
import type { TLShape } from 'tldraw'
import { renderPlaintextFromRichText } from 'tldraw'

function hasRichText(shape: TLShape): boolean {
  const editor = useTldrawEditor().editor
  if (editor == null) return false
  return 'richText' in shape.props && renderPlaintextFromRichText(editor, shape.props.richText) !== ''
}

function hasTextContent(shape: TLShape): boolean {
  // Connector shapes store text in props.text
  // All other shapes store text as rich text in props.richText
  // This check handles both cases to determine if a shape contains any text content
  return ('text' in shape.props && shape.props.text !== '') || hasRichText(shape)
}

function getTextContent(shape: TLShape): string | null {
  const editor = useTldrawEditor().editor
  if (editor == null) return null
  if ('text' in shape.props) return shape.props.text
  if ('richText' in shape.props) return renderPlaintextFromRichText(editor, shape.props.richText)
  return null
}

export { getTextContent, hasRichText, hasTextContent }
